const LINK_RE = /(https?:\/\/[^\s]+|[\w.+-]+@[\w-]+\.[\w.]+)/g;

const linkify = (text) => text.split(LINK_RE).map((part, i) => {
  if (!part.match(LINK_RE)) return part;
  const href = part.includes("@") && !part.startsWith("http") ? `mailto:${part}` : part;
  return <a key={i} href={href} className="text-[#00E5FF] underline break-all">{part}</a>;
});

const LABEL_RE = /^([A-Z][^:]{1,45}):\s*(.*)$/;

function Line({ text }) {
  const m = text.match(LABEL_RE);
  if (m && m[1].split(" ").length <= 5) {
    return <p><b className="text-white">{m[1]}:</b> {linkify(m[2])}</p>;
  }
  return <p>{linkify(text)}</p>;
}

const isHeading = (l) => /^\d+\.\s/.test(l) && !/\.$/.test(l);

function Block({ line, idx }) {
  if (line.startsWith("## ")) return <h3 className="font-outfit font-bold text-[15px] text-white pt-3" data-testid={`legal-sub-${idx}`}>{line.slice(3)}</h3>;
  if (/^\d+\.\d+\s/.test(line) || /^[A-Z]\.\s/.test(line)) return <h3 className="font-outfit font-bold text-[15px] text-white pt-3" data-testid={`legal-sub-${idx}`}>{line}</h3>;
  const bullet = line.match(/^-\s+(.*)$/);
  if (bullet) return (
    <div className="flex gap-2 pl-2"><span className="text-[#FF7A00] font-bold flex-shrink-0">•</span><span>{linkify(bullet[1])}</span></div>
  );
  const li = line.match(/^([a-z]|\d+)\.\s+(.*)$/);
  if (li) return (
    <div className="flex gap-2 pl-2"><b className="text-[#FF7A00] flex-shrink-0">{li[1]}.</b><span>{linkify(li[2])}</span></div>
  );
  return <Line text={line}/>;
}

export default function LegalDoc({ text }) {
  const sections = [];
  text.trim().split("\n").map(l => l.trim()).filter(Boolean).forEach(line => {
    if (isHeading(line)) sections.push({ title: line, lines: [] });
    else if (sections.length) sections[sections.length - 1].lines.push(line);
    else sections.push({ title: null, lines: [line] });
  });
  return (
    <div className="space-y-8 text-white/85 text-sm leading-relaxed">
      {sections.map((s, i) => (
        <section key={i} className="space-y-3" data-testid={`legal-section-${i}`}>
          {s.title && <h2 className="font-outfit font-extrabold text-base text-[#FF7A00]">{s.title}</h2>}
          {s.lines.map((l, j) => <Block key={j} line={l} idx={`${i}-${j}`}/>)}
        </section>
      ))}
    </div>
  );
}
